/**
 * HIPAA F3: keep selected patient UUID out of the URL query string.
 * Stored in sessionStorage (tab-scoped) instead of ?user=.
 */
const KEY = "selectedPatientUuid";

export function setSelectedPatient(uuid) {
  if (uuid) {
    sessionStorage.setItem(KEY, String(uuid));
  } else {
    sessionStorage.removeItem(KEY);
  }
}

export function getSelectedPatient() {
  return sessionStorage.getItem(KEY) || "";
}

/** Remove legacy ?user= from the address bar without a navigation bounce. */
function stripUserQueryParam() {
  try {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("user")) return;
    url.searchParams.delete("user");
    const next = url.pathname + (url.search || "") + (url.hash || "");
    window.history.replaceState({}, "", next);
  } catch (_) {
    /* ignore */
  }
}

/** Prefer session selection; fall back to legacy ?user= once, then migrate + strip. */
export function readPatientUuidFromLocation(search = window.location.search) {
  let fromSession = getSelectedPatient();
  try {
    const q = new URLSearchParams(search).get("user");
    if (q) {
      if (!fromSession) {
        setSelectedPatient(q);
        fromSession = q;
      }
      stripUserQueryParam();
    }
  } catch (_) {
    /* ignore */
  }
  return fromSession || "";
}
